import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from 'src/http';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { LpEvent } from 'src/types/lp-events';
import { endpoints } from 'src/utils/axios';
import { Either } from 'src/utils/either';

export class LpEventsRepository {
  constructor(private api: HttpTypes.HttpClient) { }

  async getLpEventsList(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.lpEvents.lpEventsList,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getLpEventsByBusinessUnits(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.lpEvents.lpEventsByBusinessUnit,
      params: { id },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getLpEventDetails(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.lpEvents.lpEventDetails,
      params: { eventId: id },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getBusinessUnits(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.lpEvents.businessUnits,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getBusinessUnitById(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.lpEvents.businessUnitById,
      params: { BUId: id },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getAllBusinessUnits(): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.lpEvents.allBusinessUnits,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async createLpEvent(
    lpEvent: LpEvent
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.benefits.lpEvents.createLpEvent,
      body: lpEvent,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateLpEvent(
    id: string,
    lpEvent: LpEvent
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'put',
      url: endpoints.benefits.lpEvents.updateLpEvent,
      params: { id },
      body: lpEvent,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getLpEventsByBusinessUnit(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.benefits.lpEvents.lpEventsByBusinessUnit,
      params: { id },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
